module.exports = __webpack_public_path__ + "static/media/thiago-alexandre.c9201d5d.png";